import React, { useState, useEffect } from "react";
import {
    Container,Box,Typography,TextField,MenuItem,Button,TableContainer,Table,TableBody,
    TableCell,TableHead,TableRow,Paper,FormControl,Autocomplete, Checkbox, ListItemText
} from "@mui/material";
import Loader from "../../components/Loader";
import { withTranslation } from "react-i18next";
import {
    DashboardGroupLangUrl, InsertDashboardGroupUrl, GetDashboardGroupDetailsUrl,
    getFillListUrl, UpdateDashboardGroupUrl, dashboardGroupCountryActionID
} from "../../utils/constants";
import { axiosGet, axiosPost } from "../../utils/Axios";
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useToast } from '../../components/toast';
import CloseIcon from '@mui/icons-material/Close'; 
import ChevronDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ClearIcon from '@mui/icons-material/Close';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { HeaderBlock } from "@colliers/colliers-b2c";

const DashboardGroupAdd = () => {

    const { ToastComponent, showToast } = useToast();

    const { t } = useTranslation();

    const location = useLocation();
    const { groupID } = location.state || {};

    const [isLoading, setIsLoading] = useState(false);
    const [validate, setValidate] = useState(false);

    const navigate = useNavigate();

    const handleCancel = () => {
        // Logic for canceling the operation
        navigate('/dashboard-group');
        console.log("Canceled!");
    };

    useEffect(() => {
        const userInfo = localStorage.getItem("userInfo");
        if (userInfo == null) {
            navigate('/login/KeyStone_Login');
            return;
        } else {
            fetchData(); 
        }
    }, []);

    const [, setDropdownList] = useState([]);
    const [groupName, setGroupName] = useState("");

    const [countries, setCountries] = useState([]);
    const [selectedCountries, setSelectedCountries] = useState([]);
    const [selectedCountryIds, setSelectedCountryIds] = useState("");
    const [originalCountryIds, setOriginalCountryIds] = useState("");

    const [languagelist, setlanguagelist] = useState([]);
    const [originalLanguagelist, setOriginalLanguagelist] = useState([]);

    const fetchData = async () => {
        setIsLoading(true);
        try {
            const data = await axiosGet(getFillListUrl, {
                actionID: dashboardGroupCountryActionID,
                valueID: groupID?groupID:0,
                keyValue: null
            });
            if (data != null && data.length > 0) {
                setDropdownList(data);
                setCountries(data);
                if (groupID) {
                    getGroupInfo(data);
                }
            }
            else {
                console.error("Failed to fetch country list: No data found.");
            }
        }
        catch (error) {
            console.error("Error fetching country list:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const getGroupInfo = async (countryList) => {
        debugger;
        setIsLoading(true);
        try {
            const data = await axiosGet(GetDashboardGroupDetailsUrl, { editDashboardGroupID: groupID });
            if (data != null) {
                setGroupName(data.dashboardGroup);
                setlanguagelist(data.dashboardGroupLangLists);
                setSelectedCountryIds(data.countryIDs);
                setOriginalCountryIds(data.countryIDs);
                setOriginalLanguagelist(data.dashboardGroupLangLists);

                const countryIdArray = data.countryIDs.split(',').map(id => parseInt(id, 10));

                const selectedCountries = countryList.filter(country => countryIdArray.includes(Number(country.code)));

                setSelectedCountries(selectedCountries);
            }
            else {
                console.error("Failed to fetch group data: No data found.");
            }
        }
        catch (error) {
            console.error("Error fetching group data:", error);
        } finally {
            setIsLoading(false);
        }
    }

    const handleGroupNameChange = (event) => {
        setGroupName(event.target.value);
    };
    const handleLanguageChange = (index, newValue) => {
        setlanguagelist(prevList =>
            prevList.map((item, i) =>
                i === index
                    ? { ...item, name: newValue } // Update the 'name' property for the matched item
                    : item // Keep other items unchanged
            )
        );
    };


    const getLanguagesCountrywise = async (value) => {
        debugger;
        setIsLoading(true);

        try {
            const countryIds = extractCountryIds(value);
            setSelectedCountryIds(countryIds);

            const data = await axiosGet(DashboardGroupLangUrl, { countryIds });

            if (!data || data.length === 0) {
                setlanguagelist([]);
                return console.error("Failed to fetch language list: No data found.");
            }
             
            updateLanguageList(data);
        } catch (error) {
            console.error("Error fetching language list:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const extractCountryIds = (value) => {
        if (!value || value.length === 0) return "";
        return value.map(x => x.code).join(",");
    };

    const updateLanguageList = (data) => {
        if (!languagelist || languagelist.length === 0) return;

        const updatedLanguageList = data.map(item => ({ ...item, name: "" }));

        languagelist.forEach(x => {
            if (!x.name) return;

            const matchingLanguage = updatedLanguageList.find(y => y.lang === x.lang);
            if (matchingLanguage) matchingLanguage.name = x.name;
        });

        setlanguagelist(updatedLanguageList);
    };


    const handleChange = (_event, value) => {
        debugger;
        setSelectedCountries(value);
        console.log(selectedCountries);
        getLanguagesCountrywise(value);
    };
    const deepCompare = (obj1, obj2) => {
        // Convert objects to JSON strings and compare them
        return JSON.stringify(obj1) === JSON.stringify(obj2);
    };
    const compareArrays = (array1, array2) => {
        debugger;
        if (array1.length !== array2.length) return true;

        // Sort the arrays (optional, only needed if order doesn't matter)
        const sortedArray1 = [...array1].sort((a, b) => a.dashboardGroupID - b.dashboardGroupID);
        const sortedArray2 = [...array2].sort((a, b) => a.dashboardGroupID - b.dashboardGroupID);

        // Compare each object in the sorted arrays
        for (let i = 0; i < sortedArray1.length; i++) {
            if (!deepCompare(sortedArray1[i], sortedArray2[i])) {
                return true; // Arrays are different
            }
        }

        return false; // Arrays are identical
    };

    const compareCountryIds = (string1, string2) => {
        debugger;
        // Split the strings into arrays
        const array1 = string1.split(",").map(Number); // Convert to numbers if needed
        const array2 = string2.split(",").map(Number);

        // Check if lengths are different
        if (array1.length !== array2.length) return true;

        // Sort both arrays
        const sortedArray1 = array1.sort((a, b) => a - b);
        const sortedArray2 = array2.sort((a, b) => a - b);

        // Compare sorted arrays
        for (let i = 0; i < sortedArray1.length; i++) {
            if (sortedArray1[i] !== sortedArray2[i]) {
                return true; // Return false if any element is different
            }
        }
        return false; // Arrays contain the same items
    };

    const handleSave = async () => {
        setIsLoading(true);
        setValidate(true);

        if (!groupName || !selectedCountryIds) {
            console.error("Mandatory fields are required");
            setIsLoading(false);
            return;
        }

        const dashboardGroupLangListstemp = languagelist?.map(x => ({
            dashboardGroupID: groupID > 0 ? groupID : 0,
            lang: x.lang,
            name: x.name
        })) || [];

        const groupData = {
            dashboardGroupID: groupID > 0 ? groupID : 0,
            dashboardGroup: groupName || "",
            countryIDs: selectedCountryIds || "",
            countryName: "",
            status: "Active",
            action: "",
            dashboardGroupLangLists: dashboardGroupLangListstemp
        };

        const url = groupID > 0 ?
            `${UpdateDashboardGroupUrl}?isLangChanged=${compareArrays(dashboardGroupLangListstemp, originalLanguagelist)}&isCountryChanged=${compareCountryIds(selectedCountryIds, originalCountryIds)}`
            : InsertDashboardGroupUrl;

        try {
            // Implement loader
            const response = await axiosPost(url, groupData);

            if (response.code !== 200) {
                showToast('error', 'Failed to save Group!');
                console.error("Failed to process dashboard group: No data found.");
                setIsLoading(false);
                return;
            }

            setValidate(false);
            showToast('success', `Successfully ${groupID > 0 ? 'Updated' : 'Saved'}!`);
            setTimeout(() => navigate('/dashboard-group'), 1000);

        } catch (error) {
            showToast('error', `Failed to ${groupID > 0 ? 'update' : 'save'} Group!`);
            console.error(`Error processing dashboard group:`, error);
            setIsLoading(false);
        } 
    };
    const [isDropdownOpen, setDropdownOpen] = useState(false);

 
    const clickAnyWhereBut = (e, className) => {
        debugger;
        if (!e.current.target.classList.contains(className)) {
            setDropdownOpen(false); /* you have a typo for "complete/compelte" */
        }
    }
    return (
        <>
            {isLoading ? <Loader /> : <></>}
            <HeaderBlock left="" title={t('dashboardGroup.dashboardGroup')} leftCenterAlign="true" actionsCenterAlign="true" />

            <Box id="main" className="countryMain">
                {/* <Box
                    sx={{
                        textAlign: "center",
                        py: 4,
                        backgroundColor: "#EDF2FF",
                    }}
                >
                    <Typography variant="h5" sx={{ textTransform: "uppercase" }}>
                        {t('dashboardGroup.dashboardGroup')}
                    </Typography>
                </Box> */}
                <Container>
                    <Box className="margin-bottom-m border-light border-radius-soft padding-xs padding-y-base padding-x-base"
                        sx={{
                            maxWidth: 800,
                            margin: "2rem auto",
                        }}
                    >
                        <Typography className="font-size-h5 text-primary-dark margin-bottom-base text-uppercase"
                            variant="h6"
                        >
                            {t('dashboardGroup.addDashboardGroup')}
                        </Typography>
                        <Box sx={{ display: "flex", gap: 2 }}>
                            {/*<Typography variant="h6">*/}
                            {/*                         {t('dashboard_group.groupName')} <span style={{ color: 'red' }}>*</span>*/}
                            {/*</Typography>*/}
                            <TextField className="padding-top-base margin-top-s  margin-bottom-s"
                                // className="space-lab"
                                fullWidth
                                label={t('dashboardGroup.groupName')}
                                required
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                inputProps={{
                                    maxLength: 100,  // Set the maxLength to 100 characters
                                }}
                                placeholder={t('dashboardGroup.enterGroupName')}
                                variant="outlined" value={groupName} onChange={handleGroupNameChange}
                                error={validate && (groupName == "" || groupName == null)}
                                helperText={validate && !groupName ? t('dashboardGroup.pleaseEnterGroupName') : ""}
                            />
                            <FormControl className="padding-top-s  margin-bottom-base" fullWidth>
                                {/*<InputLabel>Country<span style={{ color: 'red' }}>*</span></InputLabel>*/}
                                <Autocomplete
                                    multiple
                                    ChipProps={{ deleteIcon: <CloseIcon /> }}
                                    options={countries}
                                    disableCloseOnSelect
                                    popupIcon={< ChevronDownIcon />}
                                    clearIcon={< ClearIcon />}
                                    getOptionLabel={(option) => option.description}
                                    value={selectedCountries}
                                    onChange={handleChange}
                                    autoclose={false}
                                    open={isDropdownOpen}
                                    onOpen={() => setDropdownOpen(true)}
                                    onClose={() => setDropdownOpen(false)}
                                    onBlur={() => setDropdownOpen(false)}
                                    className="App"
                                    onClick={() => clickAnyWhereBut("autoCompleteBox")}
                                    renderOption={(props, option, { selected }) =>
                                    (
                                        <MenuItem{...props}>
                                            <Checkbox
                                                icon={<CheckBoxOutlineBlankIcon />}
                                                checkedIcon={<CheckBoxIcon />}
                                                checked={selected}
                                            />
                                            <ListItemText className='margin-left-s'>
                                                {option.description}
                                            </ListItemText>
                                        </MenuItem>
                                    )}
                                    renderInput={(params) => (
                                        <TextField  {...params} label={t('dashboardGroup.selectCountries')}
                                            className="padding-top-base full-width margin-bottom-base"
                                            placeholder={t('dashboardGroup.countries')}
                                            required
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            error={validate && (selectedCountryIds == "" || selectedCountryIds == null || selectedCountryIds == undefined)}
                                            helperText={validate && !selectedCountryIds ? t('dashboardGroup.pleaseSelectCountry') : ""}
                                        />
                                    )}

                                />
                            </FormControl>
                        </Box>
                        {languagelist?.length > 0 && (
                            <Typography className=" font-size-h5 text-primary margin-bottom-xs  text-uppercase padding-top-xs" variant="h6" sx={{ mb: 2 }}>
                                {t('dashboardGroup.languageEntries')}
                            </Typography>
                        )}
                        {languagelist?.length > 0 && (
                            <TableContainer className="shadow-0" component={Paper}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>{t('dashboardGroup.languageEntries')}</TableCell>
                                            <TableCell>Name</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {languagelist.map((lang, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{lang.lang}</TableCell>
                                                <TableCell className="padding-top-none">
                                                    <TextField className="margin-top-none margin-bottom-none"
                                                        fullWidth
                                                        placeholder={`Enter name for ${lang.lang}`}
                                                        variant="outlined"
                                                        size="small"
                                                        inputProps={{
                                                            maxLength: 100,  // Set the maxLength to 100 characters
                                                        }} value={lang.name}
                                                        onChange={(e) => handleLanguageChange(index, e.target.value)}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        )}
                        <Box className="" display="flex" justifyContent="center" mt={2} gap={2}>
                            <Button className="margin-right-base"
                                variant="contained"
                                color="primary"
                                onClick={handleSave}
                            >
                                {t('dashboardGroup.save')}
                            </Button>
                            <Button
                                variant="outlined"
                                color="secondary"
                                onClick={handleCancel}
                            >
                                {t('dashboardGroup.cancel')}
                            </Button>
                        </Box>
                    </Box>
                </Container>
                {ToastComponent}
            </Box>
        </>
        //    )}
        //</>
    );
};

export default withTranslation()(DashboardGroupAdd);
